import { render, staticRenderFns } from "./MediaModal.html?vue&type=template&id=1f0acb36&scoped=true&"
import script from "./MediaModal.js?vue&type=script&lang=js&"
export * from "./MediaModal.js?vue&type=script&lang=js&"
import style0 from "./MediaModal.scss?vue&type=style&index=0&id=1f0acb36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0acb36",
  null
  
)

export default component.exports